import { render, staticRenderFns } from "./tapeOrder.vue?vue&type=template&id=388668c0&scoped=true"
import script from "./tapeOrder.vue?vue&type=script&lang=js"
export * from "./tapeOrder.vue?vue&type=script&lang=js"
import style0 from "./tapeOrder.vue?vue&type=style&index=0&id=388668c0&prod&scoped=true&lang=scss"
import style1 from "../assets/css/celect.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./tapeOrder.vue?vue&type=style&index=2&id=388668c0&prod&scoped=true&lang=scss"
import style3 from "../assets/css/mobile.scss?vue&type=style&index=3&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388668c0",
  null
  
)

export default component.exports